import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'paymentStatus',
    standalone: false
})
export class PaymentStatusPipe implements PipeTransform {

  transform(value?: number, isClass: boolean = false): string {
    switch (value) {
      case 1:
        return isClass ? 'warning' : 'Ожидает оплаты';
      case 2:
        return isClass ? 'success' : 'Оплачен';
      case 3:
        return isClass ? 'danger' : 'Отменен';
      case 4:
        return isClass ? 'info' : 'Возврат оплаты';
      default:
        return '';
    }
  }

}
